import "vite/modulepreload-polyfill";

import { initializeApp } from "@js/vue/app.js";
initializeApp();

function setVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

setVh();
window.addEventListener("resize", setVh);

import { setupParallaxElements, setupParallaxElementOverflow } from "@js/parallax.js";
setupParallaxElements();
setupParallaxElementOverflow(true);

import { onResize } from "@js/throttle.js"
onResize(() => {
	setupParallaxElementOverflow();
});

import animateButtons from "@js/buttons.js";
animateButtons();

// Custom scrollbars
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
	import.meta.hot.accept(() => {
		console.log("HMR")
	});
}
